import NftCardImageWithFlip from "./NftCardImageWithFlip";
import { NftPageFeedCardImageBase } from "./styled";

export type Props = {
  image: string;
  rearImage?: string;
};

const NftCardImage = ({ image, rearImage }: Props): JSX.Element => {
  if (rearImage) {
    return <NftCardImageWithFlip image={image} rearImage={rearImage} />;
  }

  return <NftPageFeedCardImageBase srcSet={image} />;
};

export default NftCardImage;
